module.exports = __webpack_public_path__ + "img/col040900.e40d3994.svg";